import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { supabase } from "@core/lib/supabase";

/**
 * Page de callback OAuth — gère le retour après authentification Google/SSO.
 * Supabase v2 traite automatiquement le code PKCE via onAuthStateChange,
 * ce composant attend la session puis redirige.
 */
export default function AuthCallback() {
  const { t } = useTranslation("forms");
  const navigate = useNavigate();

  useEffect(() => {
    const returnTo =
      new URLSearchParams(window.location.search).get("returnTo") ||
      localStorage.getItem("auth_return_to") ||
      "/";

    const doRedirect = (sub: { unsubscribe: () => void }) => {
      sub.unsubscribe();
      localStorage.removeItem("auth_return_to");
      navigate(returnTo, { replace: true });
    };

    // Supabase v2 PKCE : échanger le code contre une session
    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((event, session) => {
      if (event === "SIGNED_IN" && session) {
        doRedirect(subscription);
      }
    });

    // Fallback : si déjà connecté, rediriger immédiatement
    supabase.auth.getSession().then(({ data: { session } }) => {
      if (session) {
        doRedirect(subscription);
      }
    });

    return () => subscription.unsubscribe();
  }, [navigate]);

  return (
    <div className="min-h-screen-safe bg-gray-950 flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-blue-500 mx-auto mb-4" />
        <p className="text-gray-300 text-sm">{t("auth.callback.connecting")}</p>
      </div>
    </div>
  );
}
